<!-- 移动端基金持股图表组件 -->
<template>
	<div v-if="chartData.length" class="chart-wrapper">
		<MobileLineBar
			:chartOptions="{
				grid: { top: 16 },
				legend: { show: false }
			}"
			:seriesData="chartData"
			:tooltip-label="$t('enterprise.total-of-holdings')"
			:legends="[$t('enterprise.total-of-holdings')]"
			:timeFormatter="timeFormatter"
			custom-style="fund_holding"
			@data-checked="onDataChecked"
		/>
	</div>
</template>

<script setup>
import { computed, ref } from 'vue';
import MobileLineBar from '@/components/mobile/MobileLineBar.vue';
import i18n from '@/locales';

// Props 定义
const props = defineProps({
	// 图表数据
	data: {
		type: Array,
		default: () => []
	},
	// 时间格式化函数
	timeFormatter: {
		type: Function,
		default: value => {
			let arr = value.split('-');
			let target = `${arr[1]}-${arr[2]}` + '\n' + `${arr[0]}`;
			return target;
		}
	}
});

// Events 定义
const emit = defineEmits(['bar-checked']);

const barChartMap = ref(new Map());

// 图表数据
const chartData = computed(() => {
	const data = [...(props.data || [])];
	return [
		{
			type: 'bar',
			data: data.map(ele => {
				barChartMap.value.set(ele.reportDate, ele);
				return [ele.reportDate, ele.holdVolume];
			}),
			name: i18n.t('enterprise.total-of-holdings')
		}
	];
});

// 图表点击事件
const onDataChecked = ({ data }) => {
	const value = barChartMap.value.get(data);
	emit('bar-checked', value);
};
</script>

<style lang="less" scoped>
.chart-wrapper {
	width: 100%;
	height: 246px;
}
</style>
